import PrivateRoutes from 'routes/PrivateRoutes';

import NotFound from 'components/NotFound';
import Admin from 'components/admin';
import AccessLogs from 'components/admin/pages/AccessLogs/AccessLogs';
import AdminDashboard from 'components/admin/pages/Dashboard/Dashboard';
import ReportingDashboard from 'components/admin/pages/ReportingCenter/ReportingCenter';
import PayerRequests from 'components/admin/pages/Requests/Payers/PayerRequests';
import Requests from 'components/admin/pages/Requests/Requests';
import AdminSettingsContainer from 'components/admin/pages/Settings/AdminSettingsContainer';
import Roles from 'components/shared/Roles-new/Roles';

import {
  ADMIN_DATABANK,
  ADMIN_DEV_SETTINGS,
  ADMIN_INTELLIGENCE,
  ADMIN_PATIENTS,
  ADMIN_PRACTICES,
  ADMIN_PRACTITIONERS,
  ADMIN_USERS
} from './index';

const ADMIN_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="admin" />,
    children: [
      {
        path: 'admin',
        element: <Admin />,
        children: [
          {
            path: '',
            element: <AdminDashboard />
          },
          ...ADMIN_PRACTICES,
          ...ADMIN_PRACTITIONERS,
          ...ADMIN_PATIENTS,
          ...ADMIN_USERS,
          ...ADMIN_DATABANK,
          ...ADMIN_INTELLIGENCE,
          ...ADMIN_DEV_SETTINGS,
          {
            path: 'reporting-center',
            element: <ReportingDashboard />
          },
          {
            path: 'access-logs',
            element: <AccessLogs />
          },
          {
            path: 'requests',
            element: <Requests />,
            children: [
              {
                path: 'payers',
                element: <PayerRequests />
              }
            ]
          },
          {
            path: 'settings',
            element: <AdminSettingsContainer />
          },
          {
            path: 'roles',
            element: <Roles isAdmin forAdmin />
          },
          {
            path: '*',
            element: <NotFound portal="admin" />
          }
        ]
      }
    ]
  }
];

export default ADMIN_DASHBOARD;
